<template>
  <div>
    <b-row class="row justify-content-between">
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Lead Source:</label>
        <p class="viewValue">
          {{ getLeadSource }}
        </p>
      </b-col>
      <b-col
        md="4"
        class="mt-2"
        v-if="data && data.leadsource && Array.isArray(data.leadsource) && data.leadsource.length>0 && data.leadsource[0].name == 'Campaign'"
      >
        <label class="viewLabel">Campaign</label>
        <p class="viewValue">
          {{ data && hasValue(data.campaign && data.campaign.name) ? data.campaign.name : "NA" }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel">Sub Source:</label>
        <p class="viewValue">
          {{ getSubSource }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Client Name :</label>
        <p class="viewValue">{{ data && hasValue(data.name) ? data.name : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel">Lead Date :</label>
        <p class="viewValue">{{ data && hasValue(data.leaddate) ? data.leaddate : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Mobile :</label>
        <p class="viewValue">{{ data && hasValue(data.mobile) ? data.mobile : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Email:</label>
        <p class="viewValue">{{ data && hasValue(data.email) ? data.email : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Lead Category:</label>
        <p class="viewValue">
          {{ getLeadCategory }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Occupation :</label>
        <p class="viewValue">{{ data && hasValue(data.occupation) ? data.occupation : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Comapany Name :</label>
        <p class="viewValue">{{ getCompanyName }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Job Title :</label>
        <p class="viewValue">{{ data && hasValue(data.lead_jobtitle) ? data.lead_jobtitle : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Lead Cost :</label>
        <p class="viewValue">{{ data && hasValue(data.lead_cost) ? data.lead_cost : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Address :</label>
        <p class="viewValue">{{ data && hasValue(data.address) ? data.address : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Pin Code :</label>
        <p class="viewValue">{{ data && hasValue(data.pincode) ? data.pincode : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> City:</label>
        <p class="viewValue">{{ data && hasValue(data.city) ? data.city : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Area :</label>
        <p class="viewValue">{{ getArea }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> State :</label>
        <p class="viewValue">{{ data && hasValue(data.state) ? data.state : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Priority :</label>
        <p class="viewValue">{{ data && hasValue(data.priority) ? data.priority : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Remark :</label>
        <p class="viewValue">{{ data && hasValue(data.remarks) ? data.remarks : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Select Type:</label>
        <p class="viewValue">
          {{ getAssignToType || '' }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Assign to:</label>
        <p class="viewValue">
          {{ getAssignToName }}
        </p>
      </b-col>
    </b-row>

    <!-- Remarks History Section -->
    <b-row v-if="data && data.followUpData && data.followUpData.length > 0" class="mt-3">
      <b-col cols="12">
        <hr />
        <h5 class="mb-2" style="font-weight: 600; color: #7367f0;">
          <feather-icon icon="ClockIcon" size="20" class="mr-1" />
          Remarks History
        </h5>
      </b-col>
      <b-col cols="12">
        <app-timeline>
          <app-timeline-item
            v-for="(item, index) in data.followUpData"
            :key="index"
            :variant="
              item.priority == 'COLD'
                ? 'info'
                : item.priority == 'HOT'
                ? 'danger'
                : item.priority == 'WARM'
                ? 'success'
                : 'primary'
            "
          >
            <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
              <h5>
                <span style="font-weight: 600 !important">{{ getFollowupUserName(item) }}</span>
                done this Changes. And take Followup by
                <span style="font-weight: 900 !important">{{ item.followuptype }}</span>
              </h5>
              <p>{{ item.datetime ? item.datetime.split("-").reverse().join("/") : '' }}</p>
            </div>
            <p>Next Folloup: After {{ item.nextfollowupafterdays }} days</p>
            <p>Remarks: {{ item.remarks }}</p>
            <p>
              Project Name :-<span
                :style="
                  item.project_id ? 'color:green; font-weight: 600' : 'color: red'
                "
              >
                <span v-if="item.project_id == 0">Other </span>
                <span v-else>{{ item.project ? item.project.projectname : "NONE SELECTED" }}</span>
              </span>
            </p>
            <p>
              Status :-
              <b-badge
                v-if="item.status"
                variant="primary"
                class="badge-glow m-0"
              >
                {{ getStatusName(item.status) }}
              </b-badge>
              <span v-else style="color: red"> NONE SELECTED</span>
            </p>
          </app-timeline-item>
        </app-timeline>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BFormCheckbox,
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BInputGroupAppend,
  BCol,
  BInputGroup,
  BFormFile,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BBadge,
} from "bootstrap-vue";
import axios from "@/components/axios";
import Attachment from "@/components/Attechment.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
export default {
  components: {
    BFormCheckbox,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BFormFile,
    Attachment,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BImg,
    BBadge,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    closepopup: {
      default: () => {},
    },
    selectedID: {
      default: 0,
    },
  },
  data() {
    return {
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      data: {},
      name: "",
      loginData: JSON.parse(localStorage.getItem("userData")),
      invoiceno: "",
      users: [],
      leadStages: [],
      assigntoRole: null, // Store fetched role separately
    };
  },
  mounted() {
    this.users = this.$store.state.app.all_users || [];
    this.getLeadStages();
    if (this.selectedID) {
      this.getData();
    }
  },
  watch: {
    selectedID(newVal) {
      if (newVal) {
        this.data = {}; // Reset data when selectedID changes
        this.getData();
      }
    }
  },
  methods: {
    async getLeadStages() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/leadstage`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((response) => {
          this.leadStages = response.data.data.data || response.data.data || [];
        })
        .catch((error) => console.log(error, "error"));
    },
    async getData() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/getleadById/${this.selectedID}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.data = Array.isArray(json.data.data) ? json.data.data[0] : json.data.data;
          
          // Sort followup data by date (most recent first)
          if (this.data && this.data.followUpData && this.data.followUpData.length > 0) {
            this.data.followUpData.sort((a, b) => {
              return new Date(b.datetime) - new Date(a.datetime);
            });
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    getStatusName(status) {
      if (!status) return 'NONE SELECTED';
      
      // If status is already an object with name, return it
      if (typeof status === 'object' && status.name) {
        return status.name;
      }
      
      // Convert status to number for comparison (status could be string or number)
      const statusId = typeof status === 'object' ? status.id : parseInt(status);
      const stage = this.leadStages.find(s => s.id === statusId);
      return stage ? stage.name : status;
    },
    getFollowupUserName(followup) {
      // enterby is a user ID number, find the user from the users list
      if (followup.enterby && typeof followup.enterby === 'number') {
        const user = this.users.find(u => u.id === followup.enterby);
        if (user) {
          return user.fullname || user.name || 'User #' + followup.enterby;
        }
      }
      
      // Check other possible fields for user data
      if (followup.enterby_data && followup.enterby_data.length > 0) {
        return followup.enterby_data[0].name || followup.enterby_data[0].fullname || 'Unknown';
      }
      if (followup.enterby && typeof followup.enterby === 'object') {
        return followup.enterby.name || followup.enterby.fullname || 'Unknown';
      }
      if (followup.enterby && typeof followup.enterby === 'string') {
        return followup.enterby;
      }
      if (followup.user) {
        return followup.user.name || followup.user.fullname || 'Unknown';
      }
      return 'System';
    },
    hasValue(value) {
      // Check if value exists (not null, not undefined, not empty string)
      // For numbers, 0 is a valid value
      return value != null && value !== '';
    },
    async fetchAssigntoRoleIfNeeded() {
      // New API structure: assignedToUser should already have role, so no need to fetch
      // Only fetch if using old structure and role is missing
      
      // Check if assignedToUser exists (new structure) - no need to fetch
      if (this.data.assignedToUser && this.data.assignedToUser.role) {
        return; // Role already available in assignedToUser
      }
      
      // Fallback: If using old structure and role is missing, fetch it
      let assigntoData = null;
      let assigntoId = null;
      
      if (this.data.assignto) {
        if (Array.isArray(this.data.assignto) && this.data.assignto.length > 0) {
          assigntoData = this.data.assignto[0];
          assigntoId = assigntoData.id;
        } else if (typeof this.data.assignto === 'object' && !Array.isArray(this.data.assignto) && Object.keys(this.data.assignto).length > 0) {
          assigntoData = this.data.assignto;
          assigntoId = assigntoData.id;
        } else if (typeof this.data.assignto === 'number' || (typeof this.data.assignto === 'string' && this.data.assignto)) {
          // assignto might be just an ID
          assigntoId = this.data.assignto;
        }
      }
      
      // If assignto ID exists but no role in assignedToUser, fetch user details
      if (assigntoId && !this.data.assignedToUser) {
        try {
          await axios({
            method: "GET",
            url: `${this.baseApi}/getusersbyid/${assigntoId}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.accessToken}`,
            },
          })
          .then((response) => {
            if (response.data.data && response.data.data.length > 0) {
              const userData = response.data.data[0];
              // Store as assignedToUser for consistency
              this.$set(this.data, 'assignedToUser', userData);
              this.assigntoRole = userData.role;
            }
          })
          .catch((error) => console.log(error, "error fetching user details"));
        } catch (error) {
          console.log(error, "error");
        }
      }
    },
  },
  computed: {
    getSubSource() {
      if (!this.data) {
        return "NA";
      }
      if (this.data.subsource && Array.isArray(this.data.subsource) && this.data.subsource.length > 0) {
        if (this.hasValue(this.data.subsource[0].name)) {
          return this.data.subsource[0].name;
        }
        if (this.hasValue(this.data.subsource[0].fullname)) {
          return this.data.subsource[0].fullname;
        }
      }
      // Check if subsource is an object (not array)
      if (this.data.subsource && typeof this.data.subsource === 'object' && !Array.isArray(this.data.subsource)) {
        if (this.hasValue(this.data.subsource.name)) {
          return this.data.subsource.name;
        }
        if (this.hasValue(this.data.subsource.fullname)) {
          return this.data.subsource.fullname;
        }
      }
      return "NA";
    },
    getArea() {
      if (!this.data) {
        return "NA";
      }
      // Check if area is an object with name property
      if (this.data.area && typeof this.data.area === 'object' && !Array.isArray(this.data.area)) {
        if (this.hasValue(this.data.area.name)) {
          return this.data.area.name;
        }
      }
      // Check if area is a string or number
      if (this.hasValue(this.data.area)) {
        return this.data.area;
      }
      return "NA";
    },
    getAssignToType() {
      // Safety check: if data is not loaded yet, return empty
      if (!this.data) {
        return null;
      }
      
      // Note: selectedType is NOT saved to database, it's only a frontend field
      // Logic: If Assign To name matches logged-in user name, type is "Self"
      // Otherwise, derive type from assigned user's role
      
      // Get logged-in user name
      const loginUserName = this.loginData ? (this.loginData.fullname || this.loginData.name || '').toLowerCase().trim() : '';
      
      // Get assigned user name (access as property, not function)
      const assignedUserName = this.getAssignToName;
      const assignedUserNameLower = assignedUserName && assignedUserName !== "missing" ? assignedUserName.toLowerCase().trim() : '';
      
      // If assigned user name matches logged-in user name, type is "Self"
      if (loginUserName && assignedUserNameLower && loginUserName === assignedUserNameLower) {
        return "Self";
      }
      
      // If names don't match or assigned user exists, derive type from role
      // Check if assignedToUser exists (new API structure)
      if (this.data.assignedToUser && typeof this.data.assignedToUser === 'object') {
        // Check for type field in assignedToUser object (if backend provides it)
        if (this.hasValue(this.data.assignedToUser.type)) {
          return this.data.assignedToUser.type;
        }
        // Derive type from role in assignedToUser
        if (this.data.assignedToUser.role) {
          const roleValue = typeof this.data.assignedToUser.role === 'string' ? this.data.assignedToUser.role.toLowerCase() : this.data.assignedToUser.role;
          const mappedType = this.mapRoleToType(roleValue);
          if (mappedType !== null) {
            return mappedType;
          }
        }
      }
      
      // Fallback: Check old structure (assignto as array/object) for backward compatibility
      let assigntoData = null;
      if (this.data.assignto) {
        if (Array.isArray(this.data.assignto) && this.data.assignto.length > 0) {
          assigntoData = this.data.assignto[0];
        } else if (typeof this.data.assignto === 'object' && !Array.isArray(this.data.assignto) && Object.keys(this.data.assignto).length > 0) {
          assigntoData = this.data.assignto;
        }
      }
      
      // If assignto exists, derive type from role
      if (assigntoData) {
        // Check for type field in assignto object (if backend provides it)
        if (this.hasValue(assigntoData.type)) {
          return assigntoData.type;
        }
        // Get role from assigntoData or from fetched role
        const role = assigntoData.role || this.assigntoRole;
        // Derive type from role (this is the main way to determine type)
        // Role might be in different formats: "employee", "channelpartner", "franchise", etc.
        if (role) {
          const roleValue = typeof role === 'string' ? role.toLowerCase() : role;
          const mappedType = this.mapRoleToType(roleValue);
          if (mappedType !== null) {
            return mappedType;
          }
        }
        // If assignto exists but can't determine type, return null (empty)
        return null;
      } else {
        // If assignto is empty/null/undefined/empty array, type is "Self"
        return "Self";
      }
    },
    mapRoleToType(role) {
      // Map role values to type names (matching AddLead.vue logic)
      // Handle different case variations
      const roleLower = typeof role === 'string' ? role.toLowerCase().trim() : String(role).toLowerCase().trim();
      
      if (roleLower === "channelpartner" || roleLower === "channel partner") {
        return "Channel Partner";
      } else if (roleLower === "franchise") {
        return "Franchise";
      } else if (roleLower === "employee") {
        return "Employee";
      } else {
        // If role doesn't match known types, return null (empty) instead of "NA"
        // because if assignto exists, it can't be "Self", and we want null for edit form
        return null;
      }
    },
    getAssignToName() {
      // Safety check: if data is not loaded yet, return "missing"
      if (!this.data) {
        return "missing";
      }
      
      // Check new API structure first: assignedToUser
      if (this.data.assignedToUser && typeof this.data.assignedToUser === 'object') {
        if (this.hasValue(this.data.assignedToUser.fullname)) {
          return this.data.assignedToUser.fullname;
        }
        if (this.hasValue(this.data.assignedToUser.name)) {
          return this.data.assignedToUser.name;
        }
      }
      
      // Fallback: Check old structure (assignto as array/object) for backward compatibility
      if (this.data.assignto && Array.isArray(this.data.assignto) && this.data.assignto.length > 0) {
        if (this.hasValue(this.data.assignto[0].name)) {
          return this.data.assignto[0].name;
        }
        if (this.hasValue(this.data.assignto[0].fullname)) {
          return this.data.assignto[0].fullname;
        }
      }
      // Check if assignto is an object (not array)
      if (this.data.assignto && typeof this.data.assignto === 'object' && !Array.isArray(this.data.assignto)) {
        if (this.hasValue(this.data.assignto.name)) {
          return this.data.assignto.name;
        }
        if (this.hasValue(this.data.assignto.fullname)) {
          return this.data.assignto.fullname;
        }
      }
      // If assign to value is missing, return "missing"
      return "missing";
    },
    getLeadSource() {
      if (!this.data) {
        return "NA";
      }
      if (this.data.leadsource && Array.isArray(this.data.leadsource) && this.data.leadsource.length > 0) {
        if (this.hasValue(this.data.leadsource[0].name)) {
          return this.data.leadsource[0].name;
        }
      }
      // Check if leadsource is an object (not array)
      if (this.data.leadsource && typeof this.data.leadsource === 'object' && !Array.isArray(this.data.leadsource)) {
        if (this.hasValue(this.data.leadsource.name)) {
          return this.data.leadsource.name;
        }
      }
      return "NA";
    },
    getLeadCategory() {
      if (!this.data) {
        return "NA";
      }
      if (this.data.leadcategory && Array.isArray(this.data.leadcategory) && this.data.leadcategory.length > 0) {
        if (this.hasValue(this.data.leadcategory[0].name)) {
          return this.data.leadcategory[0].name;
        }
      }
      // Check if leadcategory is an object (not array)
      if (this.data.leadcategory && typeof this.data.leadcategory === 'object' && !Array.isArray(this.data.leadcategory)) {
        if (this.hasValue(this.data.leadcategory.name)) {
          return this.data.leadcategory.name;
        }
      }
      return "NA";
    },
    getCompanyName() {
      if (!this.data) {
        return "NA";
      }
      // Check for lead_companyname (correct field name)
      if (this.hasValue(this.data.lead_companyname)) {
        return this.data.lead_companyname;
      }
      // Fall back to previous_company if it exists
      if (this.hasValue(this.data.previous_company)) {
        return this.data.previous_company;
      }
      return "NA";
    },
  },
};
</script>
<style>
.viewLabel {
  font-size: 15px !important;
  font-weight: 500 !important;
}
.viewValue {
  font-size: 15px !important;
  color: black;
}
</style>

